<template>
  <div>
    <div class="title">
      <h3>
        {{$t('dashboard.payments.title')}}
      </h3>
    </div>
    <ResourceTable
      :resource="paymentsTable.resource"
      :params="paymentsTable.options"
    >
      <template slot="header">
        <th>
          {{$t('dashboard.payments.table.date')}}
        </th>
        <th>
          {{$t('dashboard.payments.table.amount')}}
        </th>
        <th>
          {{$t('dashboard.payments.table.currency')}}
        </th>
        <th>
          {{$t('dashboard.payments.table.status')}}
        </th>
        <th>
          {{$t('dashboard.payments.table.payment_method')}}
        </th>
      </template>
      <template slot-scope="{element}">
        <td>
          {{$d(new Date(element.created_at), 'short')}}
        </td>
        <template v-if="!element.is_preapproval">
          <td class="amount">
            {{element.show_currency.data.symbol}}
            {{Number(element.show_amount).toFixed(2 /* element.show_currency.data.decimal_precision */)}}
          </td>
          <td class="currency">
            {{element.show_currency.data.description}}
            <span class="original-payment" v-show="element.show_currency.data.id !== element.currency.data.id">
                        ({{$t('dashboard.payments.original_payment', {currency_description: element.currency.data.description, currency_symbol: element.currency.data.symbol, amount: Number(element.amount).toFixed(2 /* element.currency.data.decimal_precision */)})}})
                      </span>
          </td>
          <td>
            {{$t(`payment_status.${element.status}`)}}
          </td>
        </template>
        <template v-else>
          <td colspan="3" class="subscription-status">
            {{$t(`subscription_payment_statuses.${element.status}`)}}
          </td>
        </template>
        <td>
          {{element.payment_method.data.name}}
        </td>
      </template>
      <template slot="empty">
        {{$t('noRecords')}}
      </template>
    </ResourceTable>
  </div>
</template>
<script>
import ResourceTable from "../components/ResourceTable"
import resources from "../resources";

export default {
  name: 'PaymentsTable',
  components: {ResourceTable},
  props: ['subscription_id'],
  data(){
    return {
      // paymentsTable: null,
    }
  },
  computed: {
      paymentsTable(){
      return {
        resource: resources.payments,
        options: {
          subscription_id: this.subscription_id,
          include: ['payment_method', 'currency', 'show_currency'],
          order_by: [['created_at', 'desc']],
          user_id: this.$auth.user().id,
        },
      };
    },
  },
}
</script>
<style lang="scss" scoped>

.title{
  h3{
    background-color: grey;
    color: #ffffff;
    font-weight: bolder;
    text-transform: uppercase;
    font-size: 1.3em;
    margin: 0 0 1em 0;
    padding: 5px 1em;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
  }
}

td,th{
  word-break: normal;
}

td.amount{
  width: 125px;
  text-align: right;
}

td.currency{
  line-height: 1.7em;
  font-size: .8em;
  
  .original-payment{
    opacity: .65;
    font-size: .9em;
  }
}

td.subscription-status{
  text-align: center;
}


</style>